function matchesReferralServiceType(serviceType, forwardReferralParams) {
  // Check if matches the service type for outbound referrals
  if (forwardReferralParams?.referralType === 'outbound') {
    return forwardReferralParams.serviceTypeName === serviceType.label;
  }
  // Everything is selectable by default
  return true;
}
export default matchesReferralServiceType;
//# sourceMappingURL=matchesReferralServiceType.js.map